import 'vuetify/styles'
import './styles/app.css'
import * as CookieConsent from 'vanilla-cookieconsent'

export const app = {
  mounted () {
    this.$nextTick(() => {
      // add cookie bar here
      window.addEventListener('scroll', this.onScroll)

      // cookie consent
      CookieConsent.run({
        cookie: {
          name: 'cc_dzupnav_cz'
        },
        root: '#app',
        mode: 'opt-in',
        autoShow: true,
        revision: 0,
        manageScriptTags: true,
        autoClearCookies: true,
        hideFromBots: true,
        disablePageInteraction: false,
        categories: {
          analytics: {},
        },
        language: {
          default: 'cs',
          autoDetect: 'document',
          translations: {
            cs: {
              preferencesModal: {
                title: 'Používáme cookies!',
                acceptAllBtn: 'Přijmout vše',
                acceptNecessaryBtn: 'Přijmout nezbytné',
                savePreferencesBtn: 'Uložit nastavení',
                closeIconLabel: 'Zavřít',
                sections: [
                  {
                    title: 'Nezbytné cookies',
                    description: 'Tyto cookies jsou nezbytné pro správné fungování našich webových stránek.',
                    linkedCategory: 'necessary'
                  },
                  {
                    title: 'Analytické cookies',
                    description: 'Tyto cookies nám pomáhají zlepšit vaše uživatelské zkušenosti.',
                    linkedCategory: 'analytics',
                    cookieTable: {
                      headers: {
                        name: 'Jméno',
                        domain: 'Služba',
                        description: 'Popis',
                        expiration: 'Expirace'
                      },
                      body: [
                        {
                          name: '_ga',
                          domain: 'google.com',
                          description: 'Google Analytics',
                          expiration: '400 dní'
                        }
                      ]
                    }
                  },
                  {
                    title: 'Více informací',
                    description: 'Další informace o našich cookies a ochraně osobních údajů najdete <a href="/ochrana-osobnich-udaju" target="_blank">zde</a>.'
                  }
                ]
              },
              consentModal: {
                label: 'Nastavení cookies',
                title: 'Používáme cookies!',
                description: 'Některé cookies jsou nezbytné pro správné fungování našich webových stránek. Jiné cookies nám pomáhají zlepšit vaše uživatelské zkušenosti. Nastavte své preference a zjistěte více o našich cookies.',
                acceptAllBtn: 'Přijmout vše',
                acceptNecessaryBtn: 'Přijmout nezbytné',
                showPreferencesBtn: 'Nastavení cookies',
                footer: '<a href="/ochrana-osobnich-udaju" target="_blank">Ochrana osobních údajů</a>'
              }
            }
          }
        },
        guiOptions: {
          consentModal: {
            layout: 'box'
          },
          preferencesModal: {
            layout: 'box'
          }
        }
      })
    })
  },
  components: {

  },
  data () {
    return {
      menu: false,
      offsetTop: 0
    }
  },
  methods: {
    toggleMainMenu () {
      this.menu = !this.menu
    },
    onScroll () {
      this.offsetTop = window.scrollY
    }
  }
}
